<!-- formulario -->
<template>
  <div class="mx-12">
    <!-- {{ programa }}
    {{ idfiltro }} -->
    <v-progress-linear v-if="persona_loading" indeterminate color="indigo"></v-progress-linear>
    <div id="formularioins" ref="formularioins">
      <img class="center-block" width="60px" :src="getuniversityimg(programa.universidad_id)" alt="" />
      <h5 class="text-center mb-1 tazul">
        <b> {{ getuniversityname(programa.universidad_id) }} </b>
      </h5>
      <h5 class="text-center mt-0 tazul"><b> {{ idfiltro==1?'FORMULARIO DE PROSPECTO':'FORMULARIO DE INSCRIPCIÓN' }} </b></h5>

      <div>
        <h6 class="mb-0 tazul"><b>I. DATOS PERSONALES</b></h6>
        <div class="marco text-center">
          <v-row no-gutters>
            <v-col class="pb-0 pt-0">
              <span :class="persona.primer_apellido != '.' ? 'bordeado' : 'bordeado2'">
                {{ persona.primer_apellido }}
              </span>
              <small class="subtitle"> 1. Apellido paterno </small>
            </v-col>
            <v-col class="pb-0 pt-0">
              <span :class="persona.segundo_apellido != '.' ? 'bordeado' : 'bordeado2'">
                {{ persona.segundo_apellido }}
              </span>
              <small class="subtitle"> 2. Apellido materno </small>
            </v-col>
            <v-col class="pb-0 pt-0">
              <span :class="persona.nombres != '.' ? 'bordeado' : 'bordeado2'">
                {{ persona.nombres }}
              </span>
              <small class="subtitle"> 3. Nombre(s) </small>
            </v-col>
            <v-col class="pb-0 pt-0">
              <span :class="persona.sexo != '.' ? 'bordeado' : 'bordeado2'">
                {{ persona.sexo }}
              </span>
              <small class="subtitle"> 4. Sexo </small>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col class="pb-0 pt-0" cols="3">
              <span :class="persona.numero_documento != '.' ? 'bordeado' : 'bordeado2'">
                {{ persona.numero_documento }}
              </span>
              <small class="subtitle"> 5. C.I. o Pasaporte </small>
            </v-col>
            <v-col class="pb-0 pt-0" cols="6">
              <span :class="persona.domicilio != '.' ? 'bordeado' : 'bordeado2'">
                {{ persona.domicilio }}
              </span>
              <small class="subtitle"> 6. Dirección </small>
            </v-col>
            <v-col class="pb-0 pt-0"> </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col class="pb-0 pt-0">
              <span :class="persona.ciudad.nombre != '.' ? 'bordeado' : 'bordeado2'">
                {{ persona.ciudad.nombre }}
              </span>
              <small class="subtitle"> 7. Ciudad </small>
            </v-col>
            <v-col class="pb-0 pt-0">
              <span :class="persona.departamento.nombre != '.' ? 'bordeado' : 'bordeado2'">
                {{ persona.departamento.nombre }}
              </span>
              <small class="subtitle"> 8. Departamento </small>
            </v-col>
            <v-col class="pb-0 pt-0">
              <span :class="persona.telefono2 != '.' ? 'bordeado' : 'bordeado2'">
                {{ persona.telefono2 }}
              </span>
              <small class="subtitle"> 9. Teléfono Fijo </small>
            </v-col>
            <v-col class="pb-0 pt-0">
              <span :class="persona.telefono1 != '.' ? 'bordeado' : 'bordeado2'">
                {{ persona.telefono1 }}
              </span>
              <small class="subtitle"> 10. Teléfono Móvil </small>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col class="pb-0 pt-0" cols="6">
              <span :class="persona.email != '.' ? 'bordeado' : 'bordeado2'">
                {{ persona.email }}
              </span>
              <small class="subtitle"> 11. Correo electrónico </small>
            </v-col>
            <v-col class="pb-0 pt-0">
              <span :class="persona.fecha_nacimiento != '.' ? 'bordeado' : 'bordeado2'">
                {{ persona.fecha_nacimiento }}
              </span>
              <small class="subtitle"> 12. Fecha de Nacimiento </small>
            </v-col>
            <v-col class="pb-0 pt-0">
              <span :class="persona.estado_civil != '.' ? 'bordeado' : 'bordeado2'">
                {{ persona.estado_civil }}
              </span>
              <small class="subtitle"> 13. Estado Civil </small>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col class="pb-0 pt-0">
              <span :class="persona.concacto != '.' ? 'bordeado' : 'bordeado2'"> {{ persona.datos_laborales }} </span>
              <small class="subtitle"> 14. Persona de Contacto 1 </small>
            </v-col>
            <v-col class="pb-0 pt-0">
              <span :class="persona.contacto != '.' ? 'bordeado' : 'bordeado2'">
                {{ persona.contacto }}
              </span>
              <small class="subtitle"> 15. Teléfono de Contacto 1 </small>
            </v-col>
            <v-col class="pb-0 pt-0">
              <span :class="persona.contacto2 != '.' ? 'bordeado' : 'bordeado2'">
                {{ persona.contacto2 }}
              </span>
              <small class="subtitle"> 16. Persona de Contacto 2 </small>
            </v-col>
            <v-col class="pb-0 pt-0">
              <span :class="persona.contacto2_tel != '.' ? 'bordeado' : 'bordeado2'">
                {{ persona.contacto2_tel }}
              </span>
              <small class="subtitle"> 17. Teléfono de Contacto 2 </small>
            </v-col>
          </v-row>
        </div>
      </div>

      <div>
        <h6 class="mb-0 tazul"><b>II. DATOS ACADÉMICOS</b></h6>
        <div class="marco text-center">
          <v-row no-gutters>
            <v-col class="pb-0 pt-0" cols="3">
              <span :class="persona.grados[0].nombre != '.' ? 'bordeado' : 'bordeado2'">
                {{ persona.grados[0].nombre }}
              </span>
              <small class="subtitle"> 1. Grado Académico </small>
            </v-col>
            <v-col class="pb-0 pt-0" cols="3">
              <span :class="persona.profesiones[0].nombre != '.' ? 'bordeado' : 'bordeado2'">
                {{ persona.profesiones[0].nombre }}
              </span>
              <small class="subtitle"> 2. Profesión </small>
            </v-col>
            <v-col class="pb-0 pt-0">
              <span :class="persona.institucion.nombre != '.' ? 'bordeado' : 'bordeado2'">
                {{ persona.institucion.nombre }}
              </span>
              <small class="subtitle"> 3. Universidad de Egreso </small>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col class="pb-0 pt-0" cols="3">
              <span :class="persona.gestion != '.' ? 'bordeado' : 'bordeado2'">
                {{ persona.gestion }}
              </span>
              <small class="subtitle"> 4. Gestión (Año de Titulación) </small>
            </v-col>
            <v-col class="pb-0 pt-0" cols="3">
              <span :class="persona.fecha_inscripcion != '.' ? 'bordeado' : 'bordeado2'">
                {{ parsefechains(inscripcion.fecha_registro) }}
              </span>
              <small class="subtitle"> 5. Fecha de Inscripción </small>
            </v-col>
            <v-col class="pb-0 pt-0" style="font-size:0.75em">
              <span :class="persona.programa != '.' ? 'bordeado' : 'bordeado2'">
                {{ programa.nombre_compuesto }}
              </span>
              <small class="subtitle"> 6. Programa de Estudio (Curso - Diplomado - Maestría) </small>
            </v-col>
          </v-row>
        </div>
      </div>

      <div>
        <h6 class="mb-0 tazul"><b>III. DATOS LABORALES</b></h6>
        <div class="marco text-center">
          <v-row no-gutters>
            <v-col class="pb-0 pt-0" cols="6">
              <span :class="persona.empresa != '.' ? 'bordeado' : 'bordeado2'"> {{ persona.empresa.nombre }} </span>
              <small class="subtitle"> 1. Empresa / Institución </small>
            </v-col>
            <v-col class="pb-0 pt-0">
              <span :class="persona.cargo != '.' ? 'bordeado' : 'bordeado2'"> {{ persona.cargo }} </span>
              <small class="subtitle"> 2. Cargo </small>
            </v-col>
            <v-col class="pb-0 pt-0">
              <span :class="persona.fecha_inc != '.' ? 'bordeado' : 'bordeado2'">
                {{ persona.fecha_inc }}
              </span>
              <small class="subtitle"> 3. Fecha de Incorporación </small>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col class="pb-0 pt-0" cols="6">
              <span :class="persona.direccion != '.' ? 'bordeado' : 'bordeado2'">
                {{ persona.direccion }}
              </span>
              <small class="subtitle"> 4. Dirección </small>
            </v-col>
            <v-col class="pb-0 pt-0">
              <span :class="persona.ciudad != '.' ? 'bordeado' : 'bordeado2'"> </span>
              <small class="subtitle"> 5. Ciudad </small>
            </v-col>
            <v-col class="pb-0 pt-0">
              <span :class="persona.tel_labo != '.' ? 'bordeado' : 'bordeado2'"> {{ persona.tel_labo }} </span>
              <small class="subtitle"> 6. Teléfono </small>
            </v-col>
          </v-row>
        </div>
      </div>

      <div>
        <div class="mt-4 text-center">
          <v-row>
            <v-col class="pb-0 pt-0">
              <span class="bordeadob"> </span>
              <small class="subtitle"> Firma del Participante </small>
            </v-col>
            <v-col class="pb-0 pt-0">
              <span class="bordeadob"> </span>
              <small class="subtitle"> Firma del Asesor </small>
            </v-col>
            <v-col class="pb-0 pt-0">
              <span class="bordeadob"> </span>
              <small class="subtitle"> Firma y Sello Responsable </small>
            </v-col>
            <v-col class="pb-0 pt-0">
              <span class="bordeadob"> </span>
              <small class="subtitle"> Director de Postgrado </small>
            </v-col>
          </v-row>
        </div>
      </div>

      <div class="mt-0">
        <div class="">
          <v-row>
            <v-col class="pb-0 pt-0">
              <h6 class="text-center reqtitle">OBSERVACIONES</h6>
              <div class="marcofactura">
                <p class="mb-0"><b>FACTURA:</b></p>
                <p><b>NIT:</b></p>
                <p>
                  <small>(sino requiere factura colocar la opción no requiero factura)</small>
                </p>
              </div>
            </v-col>
            <v-col class="pb-0 pt-0">
              <h6 class="text-center reqtitle">REQUISITOS DE INSCRIPCIÓN</h6>
              <div class="req">
                <ul>
                  <li>2 fotocopias del Diploma Académico, anverso y reverso.</li>
                  <li>2 fotocopias de Título en Provisión Nacional.</li>
                  <li>2 fotocopias del Carnet de Identidad vigente.</li>
                  <li>2 fotocopias del Certificado de Nacimiento vigente.</li>
                  <li>1 fotocopia de su Hoja de vida documentado</li>
                </ul>
                <p class="mb-0">Todo en un archivador amarillo con fastener.</p>
                <p>Fecha límite para la entrega de la documentación: ___ /___ /_____</p>
              </div>
            </v-col>
          </v-row>

          <v-row class="mb-0 text-center">
            <v-col class="pb-0 pt-0 mb-0">
              <span class="bordeadob"> </span>
              <small class="subtitle"> Forma de pago. </small>
            </v-col>
            <v-col class="pb-0 pt-0 mb-0">
              <span :class="persona.matricula != '.' ? 'bordeado' : 'bordeado2'">
                {{ persona.matricula }}
              </span>
              <small class="subtitle"> Monto de Matricula </small>
            </v-col>
            <v-col class="pb-0 pt-0 mb-0">
              <span :class="persona.colegiatura != '.' ? 'bordeado' : 'bordeado2'">
                {{ persona.colegiatura }}
              </span>
              <small class="subtitle"> Monto de Colegiatura </small>
            </v-col>
            <v-col class="pb-0 pt-0 mb-0">
              <span :class="persona.cuotas != '.' ? 'bordeado' : 'bordeado2'"> {{ persona.cuotas }} </span>
              <small class="subtitle"> Cantidad Cuotas </small>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
    <div class="text-center">
      <p class="text-danger">{{ msg }}</p>
      <button class="btn btn-azul" :disabled="!valido" @click="descargarpdf()">
        <span class="glyphicon glyphicon-download-alt white--text"></span> Descargar en PDF
      </button>
    </div>
  </div>
</template>

<style lang="css">
  .tazul {
    color: #16365c;
  }
  .bordeado {
    display: inline-block;
    min-height: 22px;
    max-height: 22px;
    height: 22px !important;
    border: 1px solid black !important;
    width: 95%;
    color: black;
    font-weight: bold;
    font-size: 1em;
    margin-bottom: 0;
    padding-bottom: 0;
  }
  .bordeado2 {
    display: inline-block;
    min-height: 22px;
    max-height: 22px;
    height: 22px !important;
    border: 1px solid black !important;
    width: 95%;
    font-weight: bold;
    font-size: 1.2em;
    margin-bottom: 0;
    padding-bottom: 0;
    color: white;
  }
  .bordeadob {
    display: inline-block;
    min-height: 22px;
    max-height: 22px;
    height: 22px !important;
    border-bottom: 1px solid black !important;
    width: 95%;
    font-weight: bold;
    font-size: 1.2em;
    margin-bottom: 0;
    padding-bottom: 0;
    color: white;
  }
  .subtitle {
    display: inline-block;
    margin-bottom: 4px;
    margin-top: 0;
    padding: 0 !important;
    line-height: inherit;
    color: #16365c;
  }
  #formularioins {
    font-size: 0.8em;
  }
  .reqtitle {
    margin-bottom: 0;
    color: #16365c;
  }
  .req {
    font-size: 0.78em;
    border: 2px solid black;
    padding-bottom: 0;
    padding-left: 1.5em;
    margin-bottom: 1em;
    padding-top: 2px;
  }
  .marco {
    border: 2px solid black;
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 16px;
  }
  .marcofactura {
    border: 2px solid #70ad47;
    border-radius: 8px;
    padding-left: 16px;
    padding-right: 16px;
    padding-bottom: 14px;
    padding-top: 16px;
  }
  .mb-0 {
    margin-bottom: 0 !important;
  }
  .mb-1 {
    margin-bottom: 2px !important;
  }
  .mt-0 {
    margin-top: 0;
  }
  .mt-4 {
    margin-top: 12px;
  }
  .pb-0,
  .pt-0 {
    padding-bottom: 0 !important;
    padding-top: 0 !important ;
  }
  .no-gutters {
    margin-right: 0;
    margin-left: 0;
  }
  .row {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    margin-right: -12px;
    margin-left: -12px;
  }
  .row > .col {
    line-height: initial;
  }
</style>

<script>
  import xaxios from '@/xaxios';
  export default {
    props:{idfiltro:Number},
    data() {
      return {
        datos: [], 
        valido: false,
        msg: '',
        persona_loading: false,
        inscripcion: {},
        programa: {},
        persona: {
          institucion: {},
          ciudad: {},
          empresa: {},
          departamento: {},
          grados: [{}],
          profesiones: [{}],
        },
      };
    },
    watch: {},
    methods: {
      descargarpdf(padre) {
        const vue = this;
        padre.loadingpdf = true;
        // let elementoParaConvertir = window.$('#formularioins').html();
        let elementoParaConvertir = window.$(this.$refs.formularioins).html();
        window
          .html2pdf()
          .set({
            margin: 0.5,
            filename: `Formulario ${this.idfiltro==1?'prospecto':'inscripcion'}`,
            image: {
              type: 'jpeg',
              quality: 0.9,
            },
            html2canvas: {
              dpi: 192,
              scale: 3,
              letterRendering: true,
            },
            pagebreak: { mode: 'avoid-all' } /*corrige el salto de pagina*/,
            jsPDF: {
              unit: 'in',
              format: 'letter',
              orientation: 'portrait',
            },
          })
          .from(elementoParaConvertir)
          .toPdf()
          .output('datauristring')
          .then(function(pdfObj) {
            vue.thenpdf(pdfObj);
            padre.loadingpdf = false;
          })
          .save()
          .catch((err) => {
            window.console.log(err);
            vue.loading = false;
            padre.loadingpdf = false;
          });
      },
      thenpdf(pdfAsString) {
        var arr = pdfAsString.split(',');
        pdfAsString = arr[1];
      },
      parsefechains(f) {
        if (!f) return '';
        let fs = f.split(' ');
        let f1 = fs[0].split('-');
        return `${f1[2]}/${f1[1]}/${f1[0]}`;
      },
      getuniversityimg(iduniversidad) {
        if (iduniversidad == 2) return 'img/logo_uajms.png';
        else if (iduniversidad == 9) return 'img/sigloxxlogo.png';
        else if (iduniversidad == 52) return 'img/qrlogo.png';
        else if (iduniversidad == 128) return 'img/ubj.png';
        else if (iduniversidad == 130) return 'img/logo_wobi.jpg';
        return '';
      },
      getuniversityname(iduniversidad) {
        if (iduniversidad == 2) return 'UNIVERSIDAD AUTONOMA JUAN MISAEL SARACHO';
        else if (iduniversidad == 9) return 'UNIVERSIDAD NACIONAL SIGLO XX';
        else if (iduniversidad == 52) return 'ESCUELA DE NEGOCIOS ESAM';
        else if (iduniversidad == 128) return 'UNIVERSIDAD BENITO JUAREZ';
        else if (iduniversidad == 130) return 'WOBI - WORLDOF BUSSINESS IDEAS';
        return '';
      },
      getpersonainfo(idpersona, idprograma, idinscripcion, padre) {
        this.persona_loading = true;
        this.valido = false;
        padre.loadingpdf = true;
        this.msg = '';
        const vue = this;
        const url1 = `${process.env.VUE_APP_API_REST}/esam/persona/id/${idpersona}`;
        const url2 = `${process.env.VUE_APP_API_REST}/esam/programa/id/${idprograma}`;
        const url3 = `${process.env.VUE_APP_API_REST}/api/esam/inscripcion/id/${idinscripcion}`;
        const url4 = `${process.env.VUE_APP_API_REST}/api/v1/documentaciones/documentos/persona/${idpersona}`;
        const promise1 = xaxios.get(url1);
        const promise2 = xaxios.get(url2);
        const promise3 = xaxios.get(url3);
        const promise4 = xaxios.get(url4);
        Promise.all([promise1, promise2, promise3, promise4])
          .then(function(values) {
            // window.console.log('>>>>>',values[0].data.persona.grados);
            let data = values[0].data;
            let data2 = values[1].data;
            let data3 = values[2].data;
            let data4 = values[3].data.data;

            if (!data.persona.ciudad) data.persona.ciudad = {};
            if (!data.persona.empresa) data.persona.empresa = {};
            if (!data.persona.departamento) data.persona.departamento = {};
            if (!data.persona.grados) data.persona.grados = [{}];
            if (!data.persona.profesiones) data.persona.profesiones = [{}];
            if (!data.persona.institucion) data.persona.institucion = {};
            if (data.persona.sexo == 'M') data.persona.sexo = 'Masculino.';
            else if (data.persona.sexo == 'F') data.persona.sexo = 'Femenino.';
            if (data.persona.estado_civil == 'S') data.persona.estado_civil = 'Soltero.';
            else if (data.persona.estado_civil == 'C') data.persona.estado_civil = 'Casado.';
            let tituloprov = data4.find((x) => x.tipo_documento_id == 4);
            if (tituloprov) {
              let gestion = tituloprov.fecha_egreso.split('-')[0];
              window.console.log('tituloprov', gestion);
              data.persona.gestion = gestion;
            }
            let matricula = data3.plan_pagos?.filter((x) => x.concepto_pago_id == 1);
            let colegiatura = data3.plan_pagos?.filter((x) => x.concepto_pago_id == 2);
            let colegiatura_monto = 0;
            let colegiatura_matri = 0;
            if (colegiatura) {
              colegiatura.forEach((e) => {
                colegiatura_monto += Number(e.monto);
              });
              data.persona.cuotas = colegiatura.length;
            }
            
            if (matricula) {
              matricula.forEach((e) => {
                colegiatura_matri += Number(e.monto);
              });
            }
            if (colegiatura_monto) data.persona.colegiatura = colegiatura_monto;
            if (colegiatura_matri) data.persona.matricula = colegiatura_matri;

            vue.persona = data.persona;
            vue.programa = data2;
            vue.inscripcion = data3;
            vue.persona_loading = false;
            // padre.loadingpdf = false;
            // window.console.log('-------',data, data2, data3, data4);

            if (!vue.persona.nombres) {
              padre.loadingpdf = false;
              vue.valido = false;
              vue.msg = 'Falta el nombre.';
              vue.$emit('onmsgpdf', vue.msg);
              return;
            }
            if (!vue.persona.primer_apellido) {
              vue.persona.primer_apellido = '';
              /*vue.valido = false;
              vue.msg = 'Falta el primer apellido.';
              vue.$emit('onmsgpdf', vue.msg);
              return;*/
            }
            if (!vue.persona.numero_documento) {
              padre.loadingpdf = false;
              vue.valido = false;
              vue.msg = 'Falta el numero_documento.';
              vue.$emit('onmsgpdf', vue.msg);
              return;
            }
            if (!vue.persona.telefono1) {
              padre.loadingpdf = false;
              vue.valido = false;
              vue.msg = 'Falta el telefono movil del estudiante.';
              vue.$emit('onmsgpdf', vue.msg);
              return;
            }
            if (!vue.persona.email) {
              padre.loadingpdf = false;
              vue.valido = false;
              vue.msg = 'Falta el correo del estudiante.';
              vue.$emit('onmsgpdf', vue.msg);
              return;
            }
            let unidad = vue.$store.state.CARGO.sede.unidad_negocio;
            let is_ck = unidad == 3 || unidad == 2;
            // window.console.log('-------------unidad:', unidad);
            if (!is_ck && !vue.persona.grados[0].nombre) {
              padre.loadingpdf = false;
              vue.valido = false;
              vue.msg = 'Falta el grado academico del estudiante.';
              vue.$emit('onmsgpdf', vue.msg);
              return;
            }
            if (!vue.persona.profesiones[0].nombre) {
              padre.loadingpdf = false;
              vue.valido = false;
              vue.msg = 'Falta la profesion del estudiante.';
              vue.$emit('onmsgpdf', vue.msg);
              return;
            }
            // let sedes_ispi = [49,54,78];
            let sedeid = vue.programa.sede_id;

            if(is_ck || sedeid == 49 || (sedeid >= 54 && sedeid <= 78)){
              // 
            }else{
              if (!vue.persona.institucion.nombre) {
                padre.loadingpdf = false;
                vue.valido = false;
                vue.msg = 'Falta la institucion de egreso.';
                vue.$emit('onmsgpdf', vue.msg);
                return;
              }
            }
            // 
            if (!vue.programa.nombre_compuesto) {
              padre.loadingpdf = false;
              vue.valido = false;
              vue.msg = 'Falta el programa.';
              vue.$emit('onmsgpdf', vue.msg);
              return;
            }
            vue.valido = true;
            setTimeout(() => {
              vue.descargarpdf(padre);
            }, 250);
            //if( !vue.persona.institucion ){ vue.valido = false; vue.msg = "Falta la institucion."; return}
          })
          .catch((e) => {
            window.console.error(e);
            padre.loadingpdf = false;
            vue.valido = false;
          });
      },
    },
    mounted() {},
  };
</script>
